export default __webpack_public_path__ + "static/media/sura.5507f529.png";